<!--
  @copyright 汽车商贸管理平台 V1.0
  @year 2026
  @description Home
-->
<template>
  <div class="home">
    <!-- 用户信息 -->
    <div class="user-info" v-if="unitInfo">
      <div class="unit-name">{{ unitInfo.name || unitInfo.shortName }}</div>
      <div class="user-name">{{ username }}</div>
    </div>

    <!-- 动态菜单按钮 -->
    <div class="home-actions">
      <button
        class="home-button"
        v-for="menu in menus"
        :key="menu.menuCode"
        @click="goTo(menu.menuCode)"
      >
        {{ menu.menuName }}
      </button>

      <div v-if="loading" class="loading-text">加载中...</div>
      <div v-if="!loading && menus.length === 0" class="no-permission">
        暂无可用功能权限
      </div>
    </div>

    <!-- 退出 -->
    <div class="logout-bar">
      <div class="logout-btn" @click="logout">退  出</div>
    </div>
  </div>
</template>

<script>
import { getUserMenus, getUserUnitInfo, getUserPermissions } from "../api/index";
import { Toast } from "vant";

export default {
  name: "Home",
  data() {
    return {
      menus: [],
      unitInfo: null,
      username: "",
      userGuid: "",
      permissions: [],
      loading: true,
      // 菜单路由映射
      menuRoutes: {
        dashboard: "/dashboard",
        vehicle_inventory: "/vehicle-inventory",
        inventory_records: "/inventory-records",
      },
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      // 无 token 直接去登录页，避免空跑 3 个带鉴权接口触发 401 循环
      const curToken =
        localStorage.getItem("token") || sessionStorage.getItem("token");
      if (!curToken) {
        this.loading = false;
        this.$router.replace("/login");
        return;
      }
      try {
        // 并行请求菜单、单位信息和权限
        const [menusRes, unitRes, permRes] = await Promise.all([
          getUserMenus(),
          getUserUnitInfo(),
          getUserPermissions(),
        ]);

        if (menusRes.code === 0) {
          this.menus = menusRes.data || [];
        }

        if (unitRes.code === 0 && unitRes.data) {
          this.unitInfo = unitRes.data;
        }

        if (permRes.code === 0) {
          this.permissions = permRes.data || [];
          // 存储权限到 localStorage 供其他页面使用
          localStorage.setItem("userPermissions", JSON.stringify(this.permissions));
        }

        // 从token中获取用户名和guid
        const token = localStorage.getItem("token") || sessionStorage.getItem("token");
        if (token) {
          try {
            const payload = JSON.parse(atob(token.split(".")[1]));
            this.username = payload.username || "";
            this.userGuid = payload.user_guid || "";
          } catch (e) {
            // ignore
          }
        }
      } catch (error) {
        console.error("加载数据失败:", error);
      } finally {
        this.loading = false;
      }
    },
    goTo(menuCode) {
      const path = this.menuRoutes[menuCode];
      if (path) {
        this.$router.push(path);
      } else {
        Toast("功能开发中...");
      }
    },
    logout() {
      localStorage.removeItem("token");
      sessionStorage.removeItem("token");
      localStorage.removeItem("userInfo");
      this.$store.commit("LOGIN_OUT");
      this.$router.push("/login");
    },
  },
};
</script>

<style scoped>
.home {
  max-width: 512px;
  margin: 0 auto;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;
  position: relative;
}

.user-info {
  background: #fff;
  padding: 20px;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.unit-name {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.user-name {
  font-size: 14px;
  color: #999;
  margin-top: 4px;
}

.home-actions {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  padding-bottom: 80px;
}

.home-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 400px;
  padding: 1rem;
  border: none;
  border-radius: 8px;
  background-color: #007aff;
  color: #fff;
  font-size: 1.1rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-bottom: 1rem;
}

.home-button:active {
  background-color: #0056b3;
}

.loading-text,
.no-permission {
  color: #999;
  font-size: 14px;
  margin-top: 20px;
}

.logout-bar {
  padding: 16px;
  padding-bottom: 30px;
  text-align: center;
}

.logout-btn {
  display: inline-block;
  padding: 12px 40px;
  font-size: 20px;
  color: #999;
  cursor: pointer;
}

.logout-btn:active {
  color: #666;
}
</style>
